import React from "react";

import Dashboard from "../@Components/Dashboard";
import { Col, Content, Grid, Row } from "rsuite";

import BuyerBudgets from "../@Components/Buyers/BuyerBudgets";

const BuyerBudget: React.FC = () => {
  return (
    <Dashboard>
      {/*<PrimaryStatCards />*/}
      <Grid fluid>
        <Row className="show-grid">
          <Col className="content-card chart" xs={24}>
            <Content style={{ height: "fit-content" }}>
              <BuyerBudgets />
            </Content>
          </Col>
        </Row>
      </Grid>
    </Dashboard>
  );
};

export default BuyerBudget;
